// src/components/TelegramReminderModal.js
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTelegramPlane, FaTimes, FaArrowRight } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setActiveSection } from '../redux/slices/uiSlice';

const TelegramReminderModal = ({ isOpen, onClose, onConfigure }) => {
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    setIsVisible(isOpen);
  }, [isOpen]);

  const handleConfigure = () => {
    onConfigure();
    onClose();
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="reminder-modal-overlay" onClick={onClose}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.3 }}
            className="reminder-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="reminder-modal-close" onClick={onClose}>
              <FaTimes />
            </button>
            
            <div className="reminder-modal-icon">
              <FaTelegramPlane />
            </div>
            
            <h2>Configure Telegram Alerts</h2>
            
            <p>
              To receive real-time trading alerts via Telegram, you need to configure your bot token and chat ID.
            </p>
            
            <div className="reminder-features">
              <div className="feature-item">
                <span className="feature-icon">🔔</span>
                <span>Real-time CHoCH signals</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">⚡</span>
                <span>CISD pattern detection</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📊</span>
                <span>MSS alerts</span>
              </div>
            </div>
            
            <div className="reminder-buttons">
              <button onClick={handleConfigure} className="btn-primary-reminder">
                Configure Now <FaArrowRight />
              </button>
              <button onClick={onClose} className="btn-secondary-reminder">
                Remind Me Later
              </button>
            </div>
            
            <p className="reminder-note">
              You can always configure this later in Settings
            </p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default TelegramReminderModal;